import React, { useEffect, useState } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import helpers from '../../../services/helpers';
import Loader from '../../parts/Loader';
import { getApiData } from '../../../services/apiService';
 import { InputNumber } from 'primereact/inputnumber';
 import { InputTextarea } from 'primereact/inputtextarea';
 import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

export default function ServiceRequestRequiredPartsModal ({
    is_show = false, 
    setShow, 
    handleSubmit, 
    customer_id,
    exclude=[],
    data = {},
    service_request_id,
    product_unit_id,
}){
    const [loading, setLoading] = useState(1);
    const [name, setName] = useState('');
    const [notice, setNotice] = useState('');
    const [data_list, setDataList] = useState([]);
    const [table_data, setTableData] = useState([]);
    const [show_address_modal, setShowAddressModal] = useState(0);
    const [required_part_items, setRequiredParts] = useState([]);
    const [parts_items, setPartsItem] = useState([]);


    const parts_status = [
                    {
                        "id": "available",
                        "text": "Available"
                    },
                    {
                        "id": "pending-down-payment",
                        "text": "Pending Down Payment"
                    },
                    {
                        "id": "ordered",
                        "text": "Ordered"
                    },
                    {
                        "id": "received",
                        "text": "Received"
                    },
                    {
                        "id": "price-inquiry",
                        "text": "Price Inquiry"
                    }
                ]
   
    useEffect(() => {

    }, []);
   
    useEffect(() => {
        if(is_show) {
            fetchData()
        }
    }, [is_show]);

    async function fetchData(){
        if(!product_unit_id && !service_request_id){
            return
        }
        const endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}/required-parts/${product_unit_id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setRequiredParts(res)
            setLoading(0)
        }
        
        if(res.status === 'error'){
            setLoading(0)
            // Swal.fire({
            //     text: res.message,
            //     icon: "error",
            //     confirmButtonText: "OK",
            //     allowOutsideClick: false
            // })
            // .then((result) => {
            //     if (result.isConfirmed) {
            //         window.location.replace("/polarserv/product-units/list");
            //     }
            // })
        }
    }

    async function submitForm(e) {
        const endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}/required-parts/${product_unit_id}`)

        handleSubmit(product_unit_id, required_part_items)
        setShow(0)
        // const res = await postApiData(endpoint, form_data)

        // setLoading(0)
        // if(res.error_code){
        //     if(res.data){
        //         setReload(Math.random());
        //         console.log('errors', res.data)
        //         setErrors( res.data );
        //     }else{
        //         setErrors([])
        //     }
        //     return
        // }

        // let id = ref_id;
        // let data = {...form_data}
        // if(!id){
        //     data.id = res.data.id
        //     console.log('new', data)
        // }

        // console.log(res)

        // Swal.fire({
        //     title: "Success",
        //     text: res.message,
        //     icon: "success",
        //     confirmButtonText: "OK",
        // })
        // .then((result) => {
        //     handleSave(data)
        //     setShow(0)
        // })
    }
   
    useEffect(() => {
        let table_items_lg = []
        let table_items_sm = []


        let table_items = [];
        if (Object.keys(required_part_items).length > 0) {
            table_items = Object.entries(required_part_items).map(([key, data]) => {
                return (
                    <tr>
                        <td width={300}>
                            <InputTextarea
                                name="item_description" 
                                value={data.item_description}  
                                className="w-100"
                                maxLength={1000}
                                cols={1}
                                onChange={(e) => inputPartsChange(e, key)}
                                placeholder="Item Description"
                            />
                        </td>
                        <td>
                            <InputText
                                name="quantity" 
                                value={data.quantity}
                                inputClassName="form-control"
                                onChange={(e) => inputPartsChange(e, key)}
                                placeholder="Quantity"
                                keyfilter="num"
                            />
                        </td>
                        <td>
                            <InputNumber 
                                name="unit_price"
                                inputId="currency-ph" 
                                value={data.unit_price}  
                                onValueChange={(e) => inputPartsChange(e, key)} 
                                mode="currency" 
                                currency="PHP" 
                                locale="en-US" 
                                inputClassName="w-100" 
                            />
                        </td>
                        <td>
                            <Dropdown  
                                name='status'
                                value={data.status}
                                onChange={(e) => inputPartsChange(e, key)} 
                                options={parts_status} 
                                optionLabel="text" 
                                optionValue="id" 
                                placeholder="Select Status" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                showClear
                                filter 
                            />
                        </td>
                        <td className='text-center'><button type="button" className='btn btn-sm btn-danger' onClick={(e) => removePartsItem(e, key)}><i className='fas fa-trash'></i></button></td>
                    </tr>
                )
            })
        }
        else{
            table_items = <tr><td className='text-center' colSpan={5}>No data to display</td></tr>

        }

        setPartsItem(<tbody>{table_items}</tbody>)
    }, [required_part_items]);

    function inputPartsChange(e, index) {
        let { value, name } = e.target;

        const updated_data = [...required_part_items];
        updated_data[index][name] = value;
        setRequiredParts(updated_data)
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setName('')
        setDataList([])
        setTableData([])
        setNotice('')
    }

    function addPartsItem(){
        const updated_data = [...required_part_items];

        updated_data.push({
            id: "",
            service_id: service_request_id,
            product_unit_id: product_unit_id,
            item_description: "",
            model_no: "",
            quantity: "",
            serial_no: "",
            status: "",
            unit_price: 0    
        })
        setRequiredParts(updated_data)
    }

    function removePartsItem(e, index){
        const updated_data = [...required_part_items];
        updated_data.splice(index, 1);
        setRequiredParts(updated_data)
    }

    return (
        <>
            <Modal show={is_show} size="xl">
                <Modal.Header>
                    <h5>Required Parts</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="row">
                        <div className="col-12 table-responsive">
                            <table className='table table-hover table-condensed'>
                                <thead className='bg-light'>
                                    <tr>
                                        <th>Item Description</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Status</th>
                                        <th><button type="button" className='btn btn-sm btn-primary float-right' onClick={addPartsItem}>Add&nbsp;Item</button></th>
                                    </tr>
                                </thead>
                                {parts_items}
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button' className='btn btn-success ml-3 ' onClick={(e) => submitForm()} disabled={loading}><i className="fas fa-check mr-2" />Save</button>  
                </Modal.Footer>
            </Modal>
        </>
    )
}